/** See `src/i18n/locales/en/roles.ts`. */
export const roles = {
  form: {
    person: 'Person',
    choose: 'Auswählen…',
    grant: '{{label}} gewähren',
    revoke: '{{label}} entziehen',
    back: 'Zurück',
  },
  company: {
    title: 'Unternehmensadministratoren',
    lead: 'Ein Unternehmensadministrator verwaltet die eigenen Informationen, Abteilungen, Mitglieder und Bereitstellung dieses Unternehmens. Gewähren und Entziehen wird protokolliert.',
    label: 'Unternehmensadministrator',
    rowsLabel: 'die Unternehmensmitglieder',
  },
  department: {
    title: 'Abteilungsadministratoren (Coach)',
    lead: 'Ein Abteilungsadministrator liest die Mitglieder und Aggregate dieser Abteilung sowie — gemäß der Regel für individuellen Zugriff — die individuellen Statistiken, die ihre Einwilligungsgrundlage abdeckt. Gewähren und Entziehen wird protokolliert.',
    label: 'Abteilungsadministrator',
    rowsLabel: 'die Abteilungsmitglieder',
  },
  admins: {
    title: 'Plattformadministratoren',
    lead: 'Ein Plattformadministrator besitzt jede umfasste Berechtigung. Das Ziel einer Ernennung muss einen Login haben und eine primäre Identität sein; der letzte Administrator kann nicht abberufen werden.',
    name: 'Name',
    email: 'E-Mail',
    retire: 'Abberufen',
    rowsLabel: 'die Administratoren',
    searchPeople: 'Personen suchen',
    searchPlaceholder: 'Name oder E-Mail',
    person: 'Person',
    choose: 'Auswählen…',
    noEligible: 'Keine geeignete Person gefunden — sie benötigt einen eigenen Login.',
    appoint: 'Ernennen',
    usersLabel: 'die Benutzer der Plattform',
  },
} as const;
